export const GET_SERVICE = 'ESERVICES/get_service';
export const SHOW_SERVICE = 'ESERVICES/show_service';
export const CREATE_SERVICE = 'ESERVICES/create_service';
export const UPDATE_SERVICE = 'ESERVICES/update_service';
export const REMOVE_SERVICE = 'ESERVICES/remove_service';
export const DELETE_SERVICE = 'ESERVICES/show_service';

export const FORM_DATA = {
  name: '',
  is_active: '',
  sequence: '',
  small_icon: '',
  link: '',
};
